import {useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../../hook/useMySearchParams";
import SearchBox from "../../../../components/general/searchBox";
import Pagination from "../../../../components/general/table/pagination";
import {general} from "../../../../../store/action";
import {connect} from "react-redux";
import {useGetVisits} from "../../../../../hook/request/visit/visits";
import PatientVisitCards from "../../../../components/patients/ehr/visit/dataList/patientVisitCards";
import ShowPatientVisitModal from "../../../../components/patients/ehr/visit/showPatientVisitModal";


const dataListTitles = [
  "نام پزشک",
  "نام مرکز",
  "تاریخ و ساعت ویزیت",
  "نوع ویزیت",
  "شماره پیگیری",
]

type TFilterValues = {
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

type visitsListProps = {
  openTab?: string;
  handleShowModal: any;
}

const VisitsCardsList = ({
  openTab,
  handleShowModal
}: visitsListProps) => {

  const [width] = useWindowSize();
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [visitsData, setVisitsData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    patient: id,
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getVisitsRequest = useGetVisits(getQueryParams(filterValues), openTab === 'visits');

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    getVisitsRequest?.data?.data?.result &&
    setVisitsData(getVisitsRequest?.data?.data.result)
  }, [getVisitsRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    const _filterValues = {
      ...filterValues,
      [name]: value,
    }
    setFilterValues(_filterValues)
  }

  const doChangePage = (param: any) => {
    const _filterValues = {
      ...filterValues,
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    }
    setFilterValues(_filterValues)
  }

  return (
    <>
      <div className="card-box shadow-none rounded-0">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی ویزیت"
            />
          </div>
        </section>

        <section className="table-cont table-responsive">
          {/*{*/}
          {/*  width < 900 ?*/}
          {/*    <PatientVisitCardsBox*/}
          {/*      dataList={visitsData}*/}
          {/*      dataListTitles={dataListTitles}*/}
          {/*      isRequesting={getVisitsRequest.isPending}*/}
          {/*    /> :*/}
          {/*    <PatientVisitsTable*/}
          {/*      dataList={visitsData}*/}
          {/*      dataListTitles={dataListTitles}*/}
          {/*      isRequesting={getVisitsRequest.isPending}*/}
          {/*    />*/}
          {/*}*/}
          <PatientVisitCards
            dataList={visitsData}
            dataListTitles={dataListTitles}
            isRequesting={getVisitsRequest.isPending}
          />
          <Pagination
            paginationData={{...filterValues, ...visitsData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      {openTab === 'visits' && <ShowPatientVisitModal/>}
      {/*<DeletePatientVisitModal/>*/}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(VisitsCardsList);
